import { Button, ColorPicker as MColorPicker, Popover } from "@mantine/core";

interface Props {
  color: string | null;
  setColor: (color: string) => void;
}

const ColorPicker = ({ color, setColor }: Props) => {
  return (
    <Popover position="bottom" shadow="md">
      <Popover.Target>
        {color && color !== "clear" ? (
          <div
            style={{
              height: 40,
              width: 150,
              borderRadius: 6,
              cursor: "pointer",
              background: color,
            }}
          />
        ) : (
          <Button variant="light" h={40} w={150}>
            Select color
          </Button>
        )}
      </Popover.Target>
      <Popover.Dropdown>
        <MColorPicker
          value={color ?? ""}
          onChange={setColor}
          format="rgb"
          swatches={[
            "rgb(37, 38, 43)",
            "rgb(134, 142, 150)",
            "rgb(250, 82, 82)",
            "rgb(230, 73, 128)",
            "rgb(190, 75, 219)",
            "rgb(121, 80, 242)",
            "rgb(76, 110, 245)",
            "rgb(34, 139, 230)",
            "rgb(21, 170, 191)",
            "rgb(18, 184, 134)",
            "rgb(64, 192, 87)",
            "rgb(130, 201, 30)",
            "rgb(250, 176, 5)",
            "rgb(253, 126, 20)",
          ]}
        />
      </Popover.Dropdown>
    </Popover>
  );
};

export default ColorPicker;
